import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
const EditPostIndex = () => {
  const navigate = useNavigate();
  const { postId } = useParams();
  useEffect(() => {
    navigate(`/posts/${postId}/edit/${ROUTE_KEYS.EDIT_POST_DETAILS}`, {
      replace: true
    });
  }, []);
  return <div />;
};

export default EditPostIndex;
